<template>
  <div class="user">
    <a-spin :spinning="spinning">
    <!-- ----------------- -->
    <div class="user-title">
      用户管理
    </div>
    <!-- 搜索 -->
    <div class="serach-warp">
      <div class="margin-right-15" style="display: inline-block;vertical-align: top;">
        <search @onSearch="onSearch" placeholder="请输入用户名搜索" />
      </div>
      <div style="display: inline-block;vertical-align: top;">
        <a-button v-if="hasPerm('/user/user/k/create')" class="createrBtn" @click="showCreateClick">创建用户</a-button>
      </div>
    </div>
    <!-- 表格 -->
    <user-table ref="userTable" />
    <!-- 创建用户 -->
    <a-modal v-model="visible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
    >
      <div class="createTitle">创建用户</div>
      <a-form-model ref="createUser" v-bind="layout" :model="createUserForm" :rules="createUserFormRules">
        <a-form-model-item has-feedback label="姓名" prop="nickname">
          <a-input v-model="createUserForm.nickname" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="联系电话" prop="tel">
          <a-input v-model="createUserForm.tel" type="text" autocomplete="off" :maxLength="11" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="用户账号" prop="userName">
          <a-input v-model="createUserForm.userName" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="登录密码" prop="password">
          <a-input v-model="createUserForm.password" type="text" autocomplete="off" />
        </a-form-model-item>

      </a-form-model>

      <div class="btn-wrap">
        <a-button class="cancel margin-right-15" @click="cancel">取消</a-button>
        <a-button class="create" :loading="createUserLoading" @click="submitForm('createUser')">创建</a-button>
      </div>

    </a-modal>
    </a-spin>
  </div>
</template>

<script>
import { CreateUser } from "api/user"

import search from "@/components/content/search/Search";
import UserTable from './childComps/UserTable';
import {hasPermission} from 'utils/hasPermission'

export default {
  name: 'User',
  components: {
    search,
    UserTable
  },
  data() {
    let checkPending;
    let validateNickname = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('名字不能为空'));
      } else {
        callback();
      }
    };
    let validateUserName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('用户账号不能为空'));
      } else {
        callback();
      }
    };
    let validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('用户密码不能为空'));
      } else {
        callback();
      }
    };
    return {
      spinning: false,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
      },
      visible: false,
      createUserLoading: false,

      createUserForm: {
        nickname: "",
        tel: "",
        userName: "",
        password: "",
      },

      createUserFormRules: {
        nickname: [{validator: validateNickname, trigger: 'change'}],
        userName: [{validator: validateUserName, trigger: 'change'}],
        password: [{validator: validatePassword, trigger: 'change'}],
      }
    }
  },
  methods: {
    hasPerm(perm){
      return hasPermission(perm);
    },
    /**
    * 逻辑区
    */
    // 加载动画
    loading() {
      this.spinning = !this.spinning
    },
    // 搜索
    onSearch(value) {
      this.$refs.userTable.userName = value;
      this.$refs.userTable.pageIndex = 0;
      this.$refs.userTable.pagination.current = 1;
      this.$refs.userTable.getUserListData(0, 10, value)
    },
    // 显示创建用户
    showCreateClick() {
      this.visible = !this.visible;
    },
    // 取消创建
    cancel() {
      console.log("取消创建");
      this.visible = !this.visible;
    },
    // 创建用户
    submitForm(formName) {
      const vm = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          vm.createUserLoading = true
          vm.create()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
    * 接口区
    */
    create() {
      const vm = this;
      this.spinning = true
      CreateUser(this.createUserForm.nickname, this.createUserForm.tel, this.createUserForm.userName, this.createUserForm.password)
        .then(res => {
          console.log(res);
          this.spinning = false
          if(res.message !== "success") {
            this.$message.error(res.message);
          } else {
            this.$message.success('创建用户成功！');
            this.visible = false;
            this.createUserLoading = false;
            this.$refs.userTable.getUserListData(0, 10, this.$refs.userTable.userName)
          }
        })
        .catch(err => {
          console.log(err);
          this.createUserLoading = false;
          this.$message.error(err.message);
        })
    }
  }
}
</script>

<style lang='scss' scoped>
  .user {
    .user-title {
      font-size: 30px;
      font-weight: 500;
      color: #131212;
    }
    .serach-warp {
      margin: 15px 0;
      .createrBtn {
        color: #fff;
        background-color:rgba($color: #E84D11, $alpha: .6)
      }
    }
  }

  .createTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }
  .btn-wrap {
    text-align: center;
    margin-top: 10px;
    .create {
      color: #fff;
      background-color: #E84D11;
    }
  }
</style>
